import { Reveal } from "../components/Reveal";
import { STANDARDS } from "../data/site";

// Shared logo/typographic mark for a standards body (FSSAI has no logo art).
export function StandardMark({ s, className = "max-h-12" }) {
  if (s.src) {
    return <img src={s.src} alt={`${s.name} (${s.short})`} loading="lazy" decoding="async" width="160" height="64" className={`${className} w-auto max-w-full object-contain`} />;
  }
  return <span className="font-display text-2xl font-bold tracking-tight text-charcoal" aria-label={`${s.name} (${s.short})`}>{s.mark}</span>;
}

// Standards & industry frameworks — the bodies behind the DCC method.
// Data lives in data/site.js (single source of truth).
export function Certifications() {
  return (
    <section className="bg-paper py-24 md:py-28" aria-label="Standards and industry frameworks">
      <div className="container-x">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
          <Reveal className="lg:col-span-7">
            <p className="eyebrow">Standards &amp; industry frameworks</p>
            <h2 className="h-display mt-6 text-4xl text-charcoal sm:text-5xl">
              Standards that inform <span className="text-dcc-strong">safer, more accountable</span> work.
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-5">
            <p className="max-w-md text-sm leading-relaxed text-zinc-600 md:text-base">
              DCC methods are informed by the applicable standards and frameworks shown below. Memberships, certifications and referenced standards are stated separately.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-px border border-zinc-200 bg-zinc-200 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5" data-testid="certifications-grid">
          {STANDARDS.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.05} className="h-full">
              {/* equal-height card: mark → acronym → full name → badge pinned to one bottom baseline */}
              <div className="flex h-full min-h-[240px] flex-col bg-white p-6 transition-colors duration-300 hover:bg-paper" data-testid={`cert-${s.id}`}>
                <div className="flex h-20 items-center justify-center">
                  <StandardMark s={s} className="max-h-16" />
                </div>
                <p className="mt-8 font-mono text-xs uppercase tracking-[0.25em] text-dcc-strong">{s.short}</p>
                <p className="mt-2 text-sm leading-relaxed text-zinc-600">{s.cardName || s.name}</p>
                <p className="mt-auto pt-5">
                  <span className="inline-block border border-dcc/40 px-2 py-1 font-mono text-xs uppercase tracking-[0.2em] text-dcc-strong">{s.relation}</span>
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-8 font-mono text-[11px] leading-relaxed text-zinc-500">
            // Memberships and standards do not replace project-specific approvals, method statements or statutory obligations.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
